import { useEffect, useState } from 'react';

export default function useIsMobile(maxWidth = 768) {
  const [isMobile, setIsMobile] = useState(() => typeof window !== 'undefined' ? window.matchMedia(`(max-width: ${maxWidth}px)`).matches : false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener?.('change', handler);
    mq.addListener?.(handler);
    return () => {
      mq.removeEventListener?.('change', handler);
      mq.removeListener?.(handler);
    };
  }, [maxWidth]);
  return isMobile;
}


